/* eslint-disable @typescript-eslint/no-explicit-any */
export const isCaretAtStart = (el: any) => {
  if (!el) return false;

  const selection = window.getSelection()!;
  if (selection.rangeCount === 0) return false;

  const range = selection.getRangeAt(0);
  const preCaretRange = range.cloneRange();
  preCaretRange.selectNodeContents(el);
  preCaretRange.setEnd(range.startContainer, range.startOffset);

  return preCaretRange.toString() === "";
};

export const isCaretAtEnd = (el: any) => {
  if (!el) return false;

  const selection = window.getSelection()!;
  if (selection.rangeCount === 0) return false;

  const range = selection.getRangeAt(0);
  const postCaretRange = range.cloneRange();
  postCaretRange.selectNodeContents(el);
  postCaretRange.setStart(range.endContainer, range.endOffset);

  return postCaretRange.toString() === "";
};

export const placeCaretAtEnd = (el: any) => {
  el.focus();
  const range = document.createRange();
  range.selectNodeContents(el);
  range.collapse(false);
  const sel = window.getSelection();
  sel?.removeAllRanges();
  sel?.addRange(range);
};

export const moveCursorToElementStart = (el: any) => {
  const range = document.createRange();
  range.setStart(el, 0);
  range.setEnd(el, 0);
  const selection = window.getSelection();
  selection?.removeAllRanges();
  selection?.addRange(range);
};

export const selectElement = (el: any) => {
  const range = document.createRange();
  range.selectNodeContents(el);
  const selection = window.getSelection();
  selection?.removeAllRanges();
  selection?.addRange(range);
};
